import React, { Component, PureComponent} from 'react';
import { Button, Card, Input, Menu, Popover, Rate } from 'antd';

export const ExRate = ({rate, className}) => (
  <div className="dimio-rate rate">
    <Rate allowHalf disabled defaultValue={parseFloat(rate)}/>
  </div>
);

export const Address = (props) => (
  <div className="dimio-addreess">
    <address>{props.children}</address>
  </div>
);

export const Price = (props) => {
  if(props.children) {
    return (
      <div className="dimio-price">
        <span className='dimio-price-currency'>{props.currency}</span>
        {props.children}
        {props.schedule &&
        <span className='dimio-price-schedule'>{props.schedule}</span>
        }
      </div>
    )
  }else{
    return null;
  }
};

export const Ribbon = (props) => {
  if(props.children) {
    return (
      <div className="dimio-ribbon"><span>{props.children}</span></div>
    )
  }else{
    return null;
  }
};

export const ActionController = (props) => {
  const {title, items, index} = props;

  let content = null;
  if(items){
    const actionItems = [];
    items.map(item => {
      actionItems.push(<Menu.Item key={item.key} >{item.title}</Menu.Item>);
    });
    content = (
      <Menu
        onClick={(event) => props.onClick(event, index)}
        className='dimio-action-conroller-items'>
        {content}
      </Menu>);
  }

  return(
    <Popover
      placement="bottomRight"
      title={title}
      content={content}
      overlayClassName='dimio-action-controller'
      trigger="click">
      <Button icon='ellipsis'/>
    </Popover>
  )
}

/**
 *
 * @param props
 *  url
 *  title
 *  action
 *  className
 * @returns {*}
 * @constructor
 */
export const CardItem = (props) => {
  const ImageViewer = (props) => {
    if(props.thumb) {
      return (
        <img src={props.thumb} alt={props.title} className='thumb img-fluid'/>
      )
    }else if(props.images){
      if(props.images.length > 0) {
        return (
          <img src={props.images[0]} alt={props.title} className='thumb_m img-fluid'/>
        )
      }else{
        return (
          <img src='/img/no-photo-s.png' alt={props.title} className='thumb_e'/>
        )
      }
    }else{
      return null;
    }
  };

  return(
    <Card bodyStyle={{padding: 0}} className={props.className}>
      <div className="card-image">
        {props.url ?
          <a href={props.url}>
            <ImageViewer {...props}/>
          </a>
          :
          <ImageViewer {...props}/>
        }
        {props.overlayImageRight &&
        <div className="card-image-right">
          {props.overlayImageRight}
        </div>
        }
        {props.overlayImageTop &&
        <div className="card-image-top">
          {props.overlayImageTop}
        </div>
        }
        {props.overlayImageRightTop &&
        <div className="card-image-right-top">
          {props.overlayImageRightTop}
        </div>
        }
        {props.overlayImageBottom &&
        <div className="card-image-bottom">
          {props.overlayImageBottom}
        </div>
        }
        {props.actions &&
        <div className="card-image-actions">
          {props.actions}
        </div>
        }
      </div>
      {props.children &&
      <div className="card-body">
        <h2 className="card-title">
          {props.url ?
            <a href={props.url}>{props.title}</a>
            :
            <span>{props.title}</span>
          }
        </h2>
        {props.subtitle &&
          <div>{props.subtitle}</div>
        }
        {props.children}
        {props.actionContent &&
        <Popover
          placement="bottomRight"
          //          title='Actions'
          content={props.actionContent}
          overlayClassName='dimio-action-controller'
          trigger="click">
          <Button icon='ellipsis' className='dimio-action-controller-button' />
        </Popover>
        }
      </div>
      }
    </Card>
  )
};

/**
 * API
 * value: defaultValue
 * label: label
 * icon: icon displayed in label section
 * key:
 * onChange: onChange event
 */
export class Numeric extends PureComponent {
  constructor(props) {
    super(props);
//    console.info(props);

    this.state = {
      value: this.props.value?this.props.value:0
    };

    this.plus = this.plus.bind(this);
    this.minus = this.minus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }
  plus(){
    let value = this.state.value;
//    let value = this.props.value;
    value = value+1;
    this.setState({value: value});
    this.props.onChange(value, this.props.id);
  }
  minus(){
    let value = this.state.value;
//    let value = this.props.value;
    value = (value > 0)?value-1:0;
    this.setState({value: value});
    this.props.onChange(value, this.props.id);
  }
  onChange(e){
    e.preventDefault();
    const value = e.target.value;
    this.setState({value: value});
  }
  onBlur(e) {
    e.preventDefault();
//    console.info(e.target.value);
    if (e.target.value.length > 0) {
      this.props.onChange(parseInt(e.target.value), this.props.id);
    }
  }
  render() {
    const {icon, label} = this.props;

    return(
      <div className={`${this.props.className}`}>
        {label &&
        <label className="dimio-numeric-label">
          {icon &&
          <span className="dimio-numeric-icon">{icon}</span>
          }
          <span className="title">
            {label}
          </span>
        </label>
        }

        <Button onClick={this.minus} className='dimio-numeric-button'>
          <i className="fa fa-minus-circle" aria-hidden="true"></i>
        </Button>

        <Input
          //          defaultValue={this.props.value}
          className="dimio-numeric-input text-center"
          defaultValue={this.props.defaultValue}
          value={this.state.value}
          onBlur={this.onBlur}
          onChange={this.onChange}
        />
        <Button onClick={this.plus} className='dimio-numeric-button'>
          <i className="fa fa-plus-circle" aria-hidden="true"></i>
        </Button>

      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/DimioLibrary.js